export default __webpack_public_path__ + "static/media/KrisHeron.58adcbc1.jpg";